/**
 * Smooth scroll between flexible content sections
 */
$(function() {
    $('.page-content-1 .subnav.extra a').on('click', function(e) {
        var offset = $($(this).attr('href')).offset().top;
        var bar = $('#wpadminbar');

        e.preventDefault();

        // Adjust the offset to accommodate the WP admin bar
        if (bar.length > 0) {
            offset = offset - bar.height();
        }

        $('html, body').animate({
            scrollTop: offset
        }, 600);
    });
});
